import React from 'react';
import { AlertTriangle, LoaderCircle } from 'lucide-react';
import { useI18n } from '../../hooks/useI18n';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';

export const RevertMessageModal = ({ open, loading, error, onClose, onConfirm }) => {
  const { t } = useI18n();

  const handleClose = () => {
    if (loading) {
      return;
    }

    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      closeDisabled={loading}
      title={t('revertMessageTitle')}
      panelClassName="max-w-md rounded-[1.75rem] p-5"
      contentClassName="mb-4"
      titleClassName="text-base"
    >
      <div className="space-y-5">
        <div className="flex gap-3 rounded-2xl border border-amber-200/80 bg-amber-50/70 p-4 dark:border-amber-500/20 dark:bg-amber-500/10">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-100 text-amber-600 dark:bg-amber-500/20 dark:text-amber-200">
            <AlertTriangle size={18} />
          </span>
          <p className="text-sm leading-6 text-muted">{t('revertMessageConfirm')}</p>
        </div>

        {error ? (
          <p className="rounded-xl border border-rose-200 bg-rose-50/80 px-3 py-2 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-900/25 dark:text-rose-200">
            {error}
          </p>
        ) : null}

        <div className="flex justify-end gap-3">
          <Button type="button" variant="secondary" onClick={handleClose} disabled={loading}>
            {t('cancel')}
          </Button>
          <Button type="button" variant="danger" onClick={onConfirm} disabled={loading}>
            {loading ? (
              <>
                <LoaderCircle size={16} className="animate-spin" />
                {t('revertingMessage')}
              </>
            ) : (
              t('revertMessageConfirmButton')
            )}
          </Button>
        </div>
      </div>
    </Modal>
  );
};
